module.exports = __webpack_public_path__ + "static/media/SDG10.f5e268e4.mp4";